import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import '../../services/GlobalVariables';
import axios from 'axios';

const API_URL = global.SET_API_URL + 'kitchens/';

const initialState = {
    kitchens: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
};

export const fetchKitchens = createAsyncThunk(
    'kitchens/fetchAll',
    async (_, thunkAPI) => {
        try {
            const res = await axios.get(API_URL + 'list', { timeout: 10000 });
            return res.data.kitchens || [];
        } catch (error) {
            const message = error.code === 'ECONNABORTED'
                ? 'Kitchen API timeout: backend/database response is taking too long.'
                : (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createKitchen = createAsyncThunk(
    'kitchens/create',
    async (payload, thunkAPI) => {
        try {
            const res = await axios.post(API_URL + 'create', payload, { timeout: 10000 });
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateKitchen = createAsyncThunk(
    'kitchens/update',
    async ({ kitchenId, data }, thunkAPI) => {
        try {
            const res = await axios.put(API_URL + `update/${kitchenId}`, data, { timeout: 10000 });
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateKitchenStatus = createAsyncThunk(
    'kitchens/status',
    async (payload, thunkAPI) => {
        try {
            const res = await axios.put(API_URL + 'status', payload, { timeout: 10000 });
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteKitchen = createAsyncThunk(
    'kitchens/delete',
    async (kitchenId, thunkAPI) => {
        try {
            const res = await axios.delete(API_URL + `delete/${kitchenId}`, { timeout: 10000 });
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const kitchenSlice = createSlice({
    name: 'kitchens',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchKitchens.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchKitchens.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.kitchens = action.payload;
            })
            .addCase(fetchKitchens.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createKitchen.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createKitchen.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(createKitchen.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updateKitchen.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateKitchen.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(updateKitchen.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updateKitchenStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateKitchenStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(updateKitchenStatus.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deleteKitchen.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteKitchen.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(deleteKitchen.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    }
});

export const { reset } = kitchenSlice.actions;
export default kitchenSlice.reducer;
